import moment from 'moment';
import React, { useContext, useMemo } from 'react';
import { SearchIcon } from '../../../../../assets/icons';
import InfoPopUp from '../../../../../components/InfoPopUp';
import emissionSpoolsContext from '../../../../../context/emissionSpools/emissionSpoolsContext';
import useLatestProposal from '../../../../../hooks/web3/vault/useLatestProposal';
import useUserAvailableVotingPower from '../../../../../hooks/web3/vault/useUserAvailableVotingPower';
import EmissionSpoolsTableHeader from './EmissionSpoolsTableHeader';

type Props = {
    hasFilteredResults: boolean;
};

const EmmisionSpoolHeaders: React.FC<Props> = ({ hasFilteredResults }) => {
    const { searchTerm, setSearchTerm } = useContext(emissionSpoolsContext);
    const handleSearchTermChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setSearchTerm(value);
    };

    const { userAvailableVotingPower } = useUserAvailableVotingPower();

    const { latestProposal } = useLatestProposal();

    const { APY_BUFFER_TIME } = useContext(emissionSpoolsContext);

    const apyBufferTimeEnded = useMemo(
        () => latestProposal && latestProposal?.end + APY_BUFFER_TIME < moment().unix(),
        [latestProposal, APY_BUFFER_TIME]
    );

    return (
        <>
            <EmissionSpoolsTableHeader
                withSort={false}
                dataKey='spoolName'
                context={emissionSpoolsContext}
            >
                <div className='search-container'>
                    <input
                        type='search'
                        name='searchTerm'
                        placeholder='Name or Address'
                        autoComplete='off'
                        value={searchTerm}
                        onChange={handleSearchTermChange}
                        className={
                            searchTerm && !hasFilteredResults ? 'no-result' : undefined
                        }
                    />
                    <SearchIcon />
                </div>
            </EmissionSpoolsTableHeader>
            <EmissionSpoolsTableHeader dataKey='tvr' context={emissionSpoolsContext}>
                <div className='tvr-header'>TVR</div>
            </EmissionSpoolsTableHeader>
            <EmissionSpoolsTableHeader dataKey='apy' context={emissionSpoolsContext}>
                <div
                    className={`emission-header ${
                        apyBufferTimeEnded && 'proposal-ended'
                    }`}
                >
                    <span>{apyBufferTimeEnded ? 'Current Emission' : 'SPOOL APY'} </span>
                    {!apyBufferTimeEnded && (
                        <InfoPopUp>
                            Future emissions shown considers the APY from the votes (50%)
                            and from the profit generated in last 28 days (50%)
                        </InfoPopUp>
                    )}
                </div>
            </EmissionSpoolsTableHeader>
            <EmissionSpoolsTableHeader
                dataKey='alloc'
                context={emissionSpoolsContext}
                withSort={false}
            >
                <span>My Allocations</span>
                <InfoPopUp>
                    <span className='block'>
                        Your actionable voSPOOL:{' '}
                        {Math.floor(+(userAvailableVotingPower || 0))}
                    </span>
                    <div className='mt'>
                        Only voSPOOL you earned at the exact time of the snapshot can be
                        used for voting.
                    </div>
                </InfoPopUp>
            </EmissionSpoolsTableHeader>
            <EmissionSpoolsTableHeader
                dataKey='allocWeight'
                context={emissionSpoolsContext}
            >
                <div className='total-alloc-header'>
                    <span>Total Alloc</span>
                    <InfoPopUp>Current Voted Allocation</InfoPopUp>
                </div>
            </EmissionSpoolsTableHeader>
        </>
    );
};

export default EmmisionSpoolHeaders;
